import { setTitleForClient } from '../utils/other';
import { useAppStore } from '../stores/app';

export function useTitleForClient() {
  const app = useAppStore();

  const setTitle = (title: string) => {
    setTitleForClient(title, app.config.seo.title || app.config.name);
  };

  return {
    setTitle,
  };
}
